<template>
  <svg :class="$style.svg" viewBox="0 0 50 50" v-test="'spinner'">
    <circle
      :class="[$style.circle, { [$style.isLight]: isLight }]"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke-width="5"
    ></circle>
  </svg>
</template>

<script>
export default {
  props: {
    isLight: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" module>
.svg {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -10px;
  width: 20px;
  height: 20px;
}

.circle {
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out -1s infinite;
  stroke: #999;

  &.isLight {
    stroke: #fff;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
